import { BodyText } from '../../atomsLegacy';
import CheckboxWithLabel from '../../moleculesLegacy/CheckboxWithLabel';
import { CookiesPopup } from '../../moleculesLegacy/CookiesPopup';
import { CheckboxContainer } from './AcceptCookiesCheckbox.styles';

interface Props {
  checkboxTicked: boolean;
  setCheckboxTicked: (ticked: boolean) => void;
  hasWhiteText?: boolean;
  checkboxColor?: string;
  checkboxHasMargin?: boolean;
  cookiesPopupState: string;
  setCookiesPopupState: (state: string) => void;
  align?: 'left' | 'center' | 'right';
}

export const AcceptCookiesCheckbox = (props: Props) => {
  return (
    <CheckboxContainer noMargin={!props.checkboxHasMargin} align={props.align}>
      <CheckboxWithLabel
        checkboxLabel={
          <BodyText weight="regular" white={props.hasWhiteText}>
            I agree to essential cookies{' '}
            <span
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => props.setCookiesPopupState('info')}
              data-testid="cookies-learn-more"
            >
              Learn more
            </span>
          </BodyText>
        }
        checked={props.checkboxTicked}
        data-testid="cookie-consent-checkbox"
        onChange={() => {
          props.setCheckboxTicked(!props.checkboxTicked);
        }}
        fontSize="small"
        checkboxColor={props.checkboxColor}
      />
      {props.cookiesPopupState === 'info' && (
        <CookiesPopup
          closePopup={() => props.setCookiesPopupState('hidden')}
          popupState="info"
        />
      )}
      {props.cookiesPopupState === 'error' && (
        <CookiesPopup
          closePopup={() => props.setCookiesPopupState('hidden')}
          popupState="error"
        />
      )}
    </CheckboxContainer>
  );
};
